import type { MyProfile } from '@/types/profile'
import { BaseEntity } from './Base'
import dayjs from 'dayjs'

export class MyProfileEntity extends BaseEntity<MyProfile> {
  get birthday() {
    const { birthday: { year, month, day } } = this.data
    return dayjs(`${year}-${month}-${day}`, 'YYYY-M-D')
  }

  get addressStr() {
    const { zipCode, prefecture, address1, address2, address3 } = this.data

    return `〒${zipCode} ${prefecture || ''}${address1 || ''}${address2 || ''}${address3 || ''}`
  }

  // 注文に必須の情報が揃っているかチェック
  // Reference: https://docs.google.com/spreadsheets/d/1Hh1M49TT8sJRGC0i6X5rvPWk296CGsKNhIbtDx4p7Hk/edit#gid=951502859&range=R17
  get isMissingInfoForOrder(): boolean {
    const { displayName, zipCode, prefecture, address1, address2, phoneNumber } = this.data
    return !displayName || !zipCode || !prefecture || !address1 || !address2 || !phoneNumber
  }

  get isMissingAllInfoForOrder(): boolean {
    const { displayName, zipCode, prefecture, address1, address2, phoneNumber } = this.data
    return !displayName && !zipCode && !prefecture && !address1 && !address2 && !phoneNumber
  }
}

export const MyProfileEntityFactory = (data: Partial<MyProfile> = {}) => new MyProfileEntity({
  uid: 'xxxxxxxxxxxxxxx',
  email: 'example@ka-nabell.com',
  displayName: 'カーナベル太郎',
  zipCode: '5100064',
  prefecture: '三重県',
  address1: '四日市市',
  address2: '新正四丁目',
  address3: '６番８号 カーナビルディング',
  phoneNumber: '01234567890',
  emailVerified: true,
  birthday: {
    year: 1999,
    month: 12,
    day: 31
  },
  addresses: [
    {
      addressId: '1',
      name: 'カーナベル太郎',
      phoneNumber: '01234567890',
      zipCode: '5100064',
      prefecture: '三重県',
      address1: '四日市市',
      address2: '新正四丁目',
      address3: '６番８号 カーナビルディング101',
    },
    {
      addressId: '2',
      name: 'カーナベル太郎',
      phoneNumber: '01234567890',
      zipCode: '5100064',
      prefecture: '三重県',
      address1: '四日市市',
      address2: '新正四丁目',
      address3: '６番８号 カーナビルディング201',
    },
  ],
  ...data,
})
